import { render, staticRenderFns } from "./IconTemp.vue?vue&type=template&id=e8b3a3d8"
import script from "./IconTemp.vue?vue&type=script&lang=js"
export * from "./IconTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports